/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";
import SocialLinks from "components/SocialLinks/SocialLinks.js";
// core components

function FooterBlack() {
  return (
    <>
      <footer className="footer" data-background-color="black">
        <Container style={{ alignItems: 'center', marginBottom: '20px' }}>
          <div className="copyright float-left">
            <a href="/TerminosCondiciones">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Términos y condiciones</h6>
            </a>
            <a href="/PoliticasDatosPersonales">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Política de Tratamiento de Datos Personales</h6>
            </a>
            <a href="/PoliticasDerechosAutor">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Politícas de derechos de autor</h6>
            </a>
            <a href="/CertificadoAccesibilidad">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Certificado de Accesibilidad</h6>
            </a>
            <a href="/PoliticasPrivacidadWeb">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Políticas de Privacidad web</h6>
            </a>
            <a href="/MapaSitio">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Mapa del Sitio</h6>
            </a>
            <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Telefonos: +57 (602)3472757, +57 (602)3921183 </h6>
            <a href="/#contacto">
              <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer" }}>Canales de Atencion al publico</h6>
            </a>
          </div>
          <div className="copyright" id="copyright" >
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
              <img style={{ backgroundColor: 'white', borderRadius: "15px" }} src={require("assets/img/Notaria/logoNot.png")} alt="Logo de la notaria 21 de Cali" width="110px"></img>
            </NavbarBrand>
          </div>
        </Container>
        <div
          className="footer-social"
          style={{
            clear: 'both',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            padding: '8px 15px 4px',
          }}
        >
          <SocialLinks />
        </div>
        <div
          className="div-sinfony"
          style={{
            clear: 'both',
            backgroundColor: '#474747',
            marginTop: '20px',
            width: '100%',
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 15px',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            © {new Date().getFullYear()}, Designed by{'\u00A0'}
            <a
              href="https://www.sinfony.com.co/sinfony/"
              target="_blank"
            >
              SINFONY Todos los derechos reservados.
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterBlack;
